/**
 * FT18-U24 (FSD 2.2.5 "Revised Forecasts"): the register of every revised forecast
 * version. Spread into `BUDGET_ROUTES` by `budget/routes.ts`, so the router needs no
 * import of its own; nav id `budget-forecasts` (s-2.2.5) points here.
 */

import type { RouteRecordRaw } from 'vue-router'

import { BUDGET_PERMISSIONS } from '@/modules/budget/permissions'

export const BUDGET_FORECASTS_ROUTES: RouteRecordRaw[] = [
  {
    path: '/budget/forecasts',
    name: 'budget-forecasts',
    component: () => import('@/modules/budget/forecasts/ForecastsListView.vue'),
    meta: {
      titleKey: 'budget.routeTitles.budgetForecasts',
      permission: BUDGET_PERMISSIONS.versionRead,
    },
  },
]

export function forecastsRoute(): string {
  return '/budget/forecasts'
}
